import React from 'react'
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function WarehouseInventory() {
  return (
    <div>
    <div class="flex flex-wrap justify-center mt-8">
        <div class="w-full  flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl shadow-[0 0 15]">
        <h1 className="text-lg pl-4 mt-2 font-bold ">
        Inventory Accuracy
      </h1>
          <div className=" px-9 mt-9">
            <CircularProgressbar
              value={84}
              text={`${84}%`}
              circleRatio={0.75}
              styles={buildStyles({
                rotation: 1 / 2 + 1 / 8,
                strokeLinecap: "butt",
                // trailColor: "#26F32E",
                textColor: "black",
                pathColor: "#26F32E",
                // trailColor: "gold"
              })}
            />
          </div>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
          Inventory Accuracy
          </h1>
          <p className="text-red-600 text-center pt-2 ">
            <span>
              <span className="inline-block">
                {" "}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
              <span className="ml-1 font-medium">45.38%</span>
            </span>
          </p>
          <div className="text-center mb-4  mt-4">
            <div className="">
              <button className="rounded-full w-24 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                February
                              </button>
            </div>
          </div>
        </div>
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto bg-white  flex-4 sm:w-1/2 md:w-1/3 lg:w-2/3  xl:w-1/6 mb-4 mx-4 shadow-md shadow-slate-400 rounded-xl">
         
          <div
            className="tabelcontainer overflow-auto mt-2 pt-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <div className="flex pt-8">
              {" "}
              <h3 className="text-2xl font-bold ml-3 pl-8">
                {" "}
                243,367,383
              </h3>{" "}
              <h3 className="text-xl ml-2"> Items</h3>
            </div>

            <div className="p-16">
              <div class="w-full h-6 bg-cyan-200  rounded-full ">
                <div
                  class="h-6 bg-blue-200 rounded-full "
                  style={{ width: "85%" }}
                ></div>
              </div>
            </div>
            <div className="flex p-16 -mt-28 ml-4">
              <div className=" text-center w-fit align-middle text-gray-400 cursor-pointer pb-2">
                <div className="flex">
                  <div class="w-12 h-6 bg-blue-200 rounded-full "></div>
                  <p className="ml-5"> Real Inventory</p>
                </div>
                <p className="font-bold text-lg text-black ml-16">
                  24,496,362 items
                </p>
              </div>
              <div className=" text-center w-fit align-middle ml-6 text-gray-400 cursor-pointer pb-2">
                <div className="flex ml-5">
                  <div class="w-12 h-6 bg-cyan-200 rounded-full "></div>
                  <p className="ml-5"> Expected Inventory</p>{" "}
                </div>
                <p className="font-bold text-lg text-black ml-16">654 items</p>
              </div>
            </div>
            <div className="flex px-16 pt-16 -mt-28 ml-4">
            <div className=" text-center w-fit align-middle text-gray-400 cursor-pointer pb-2">
              <div className="flex">
                
                <p className="ml-8 text-lg pl-8 mt-4"> Last Stock Take: </p><p className="font-bold text-lg text-black ml-4 mt-4">
                05/03/2022
              </p>
              </div>
              
            </div>
            
          </div>
          <div className="float-right mb-4 mr-4 pr-4 ">
            <div className="">
              <button className="rounded-lg w-fit p-4 text-white hover:bg-cyan-200 hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Stock Take
              </button>
            </div>
          </div>
          </div>
        </div>
      </div>
    
    
    </div>
  )
}
